import React from "react";
import { Phone } from "lucide-react";
import { businessInfo } from "../data/mock";
import "../styles/Hero.css";

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-image-bg">
        <img
          src="https://images.pexels.com/photos/7446675/pexels-photo-7446675.jpeg?auto=compress&cs=tinysrgb&w=1200"
          alt="Professional aesthetic treatment"
        />
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content-wrapper">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-large">AURA AESTHETICS ACADEMY</h1>
            <h2 className="heading-2">Advanced Aesthetics & Beauty Treatments for Radiant, Confident Skin</h2>
            <p className="body-large hero-description">
              Aura Aesthetics Academy elevates your beauty and wellness with personalized IV infusions, 
              facial treatments, and advanced aesthetic procedures.
            </p>
            <div className="hero-actions">
              <a href={`tel:${businessInfo.phone}`} className="btn-icon">
                <Phone size={18} /> {businessInfo.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
